import { FC } from 'react';
import { useIntl } from 'react-intl';

import { useAppSelector } from '@/shared/hooks';

import { toolbarMIRModel } from '@/entities/toolbarMIR';

import {
  toothNumberEditModel,
  useToothNumberEditing,
} from '@/features/toothNumberEdit';

import { ChangeToothNumberPopup } from '@/widgets/TeethNumberingModal/ui/ChangeToothNumberPopup/ChangeToothNumberPopup';

export const ToothNumberEditPopup: FC = () => {
  const { formatMessage } = useIntl();

  const {
    selectedTooth,
    dentalNotationFormat,
    selectTooth,
    handleChangeToothNumber,
    handleRemoveTooth,
  } = useToothNumberEditing();

  const isEditingToothNumbers = useAppSelector(
    toolbarMIRModel.selectors.selectIsEditingTeeth('main'),
  );

  const pendingChanges = useAppSelector(
    toothNumberEditModel.selectors.selectPendingChanges,
  );

  const pendingToothNumber = pendingChanges.find(
    (change) => change.tooth.detectionID === selectedTooth?.detectionID,
  )?.newNumber;

  const title = formatMessage({
    id: 'report.EditTeethNumbers',
    defaultMessage: 'Edit teeth numbers',
  });

  if (!isEditingToothNumbers) {
    return null;
  }

  return (
    selectedTooth && (
      <ChangeToothNumberPopup
        isOpen={!!selectedTooth}
        onChangeToothNumber={handleChangeToothNumber}
        title={title}
        selectedTooth={selectedTooth}
        dentalNotationFormat={dentalNotationFormat}
        onRemoveTooth={handleRemoveTooth}
        selectTooth={selectTooth}
        pendingNumber={pendingToothNumber}
      />
    )
  );
};
